import React, { useRef, useState } from 'react'
import checked_red from "../../assets/images/icons/checked_24px_red.svg"
import closed_red from "../../assets/images/icons/icon_close_24px.svg"
import { PrimaryButton } from './../../components/StyledButtons';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import { t } from 'i18next';
import { LinkWhiteHoverOrange } from '../../components/StyledComponents';
import ModalContactGetTrialForm from '../../components/ModalContactGetTrialForm';
import ModalPricingCloudPlans from './ModalPricingCloudPlans';

const PricingCloudPlansComparison = () => {
    const language = useSelector(selectLanguage)

    const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);
    const [modalCloudPlansOpen,setModalCloudPlansOpen] = useState(false)

    const modalGetTrialRef = useRef(null);
    const modalCloudPlansRef = useRef(null)

    const handleOverlayClick = (event) => {
        if (modalGetTrialRef.current && !modalGetTrialRef.current.contains(event.target)) {
            setModalGetTrialOpen(false)
        }
        if (modalCloudPlansRef.current && !modalCloudPlansRef.current.contains(event.target)) {
            setModalCloudPlansOpen(false)
        }
    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalGetTrialOpen(false)
            setModalCloudPlansOpen(false)
        }
    };

    return (
        <>
            {language === "en"
                ?
                <div className='pricing_cloud-plans__comparison container pt-50' id="targetSection">
                    <p className='font-48 text-white text-center'>Cloud Plans Feature <span className='title'>Comparison</span></p>
                    <div className='row table pt-50'>
                        <div className='table-header'>
                            <div className="hidden xl-block col-xl-4">
                                <div>
                                    <p className='text-left'>Features</p>
                                </div>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Entry plan</p>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Standard plan</p>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Business plan</p>
                            </div>
                            <div className="col-sm-3 col-xl-2">
                                <p>Usage Based</p>
                            </div>

                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Number of Codes per month</p>
                                            <p className='text-left table-sub-title pt-5'>Qrypto Secure Codes generated</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>250/month + extra 30¢ per code</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>900/month + extra 20¢ per code</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>3500/month + extra 15¢ per code</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>Pricing based on volumes</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Maximum Size per EDC Code</p>
                                            <p className='text-left table-sub-title pt-5'>This is the maximum size of all data and attached files for a secure EDC code.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>10MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>25MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>50MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>As Per Need</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col pt-xl-8'>
                                            <p className='text-left font-weight-semi-bold table-title'>Total Storage</p>
                                            <p className='text-left table-sub-title pt-5'>Total storage used by all attachments</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Unlimited</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Unlimited</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Unlimited</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>N.A.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>API Tokens</p>
                                            <p className='text-left table-sub-title pt-5'>Setup and Manage API Tokens to be used by your applications to generate secure documents</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Your S3 Bucket Integration</p>
                                            <p className='text-left table-sub-title pt-5'>Use your own Amazon AWS storage service (S3) to store attachments</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Web Validator</p>
                                            <p className='text-left table-sub-title pt-5'>Validate secure codes using just the browser and your domain.
                                                <br />
                                                <LinkWhiteHoverOrange href="https://validation.qrypto.ee" target='_blank'>Example:https://validation.qrypto.ee</LinkWhiteHoverOrange>
                                            </p>

                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Web Validator Customization</p>
                                            <p className='text-left table-sub-title pt-5'>Customization of the Web validation page</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p className='pt-xl-12'>
                                            Only Logo
                                        </p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>QR - URL Option</p>
                                            <p className='text-left table-sub-title pt-5'>This makes the Secure QR content a URL enabling use of generic QR code scanners. This can have security implications - please get in touch for guidance.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">

                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>

                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Primary Data Code (PDC)</p>
                                            <p className='text-left table-sub-title pt-5'>Create self-contained Text only QR Codes for offline validation. See <LinkWhiteHoverOrange href="technology/overview">PDC vs EDC</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>PDF Stamping</p>
                                            <p className='text-left table-sub-title pt-5'>Secure an existing PDF by stamping a secure QR code on the existing PDF file. <LinkWhiteHoverOrange>Read More</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>PDF Generation: One-time Setup fee per template</p>
                                            <p className='text-left table-sub-title pt-5'>Generate Secure PDF with variable data and with Qrypto Secure QR code added for easy validation.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-34'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-34'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-34'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-34'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Number of Users</p>
                                            <p className='text-left table-sub-title pt-5'>Your staff using the system to generate Secure Codes/Documents. Anyone validating the codes are not counted as users.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>5 + extra $5 per user</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>10 + extra $5 per user</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>25 + extra $5 per user</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>As Per Need</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Sub-Accounts</p>
                                            <p className='text-left table-sub-title pt-5'>Your staff using the system to generate Secure Combine usage across various domains if your organization manages several domains. Each additional domain is a sub- account</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">

                                        <div className='pt-xl-30'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>

                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-18'>
                                            <p>$25 per sub-account with 250 bonus codes</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>As Per Need</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>KSA e-Invoice QR</p>
                                            <p className='text-left table-sub-title pt-5'>Qrypto provides ready to use QR solution for Phase 1 of KSA e- invoicing</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body' style={{ borderBottom: "none" }}>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>SLA</p>
                                            <p className='text-left table-sub-title pt-5'>Service Level Agreement.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-footer'>
                            <div className="hidden xl-block col-xl-4">
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>Sign up</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>Sign up</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>Sign up</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalCloudPlansOpen(true)}>Contact Us</PrimaryButton>
                            </div>
                            <div className='col-xs-12 pt-20'>
                                <p className='font-weight-semi-bold'>Start with free trial for Standard and then choose a paid plan</p>
                                <p className='italic text-gray'>All prices are in USD</p>
                            </div>
                        </div>
                    </div>
                </div>
                :
                //VI
                <div className='pricing_cloud-plans__comparison container pt-50' id="targetSection">
                    <p className='font-48 text-white text-center'><span className='title'>So sánh</span> tính năng gói đám mây</p>
                    <div className='row table pt-50'>
                        <div className='table-header'>
                            <div className="hidden xl-block col-xl-4">
                                <div>
                                    <p className='text-left'>Tính năng</p>
                                </div>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Gói ban đầu</p>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Gói tiêu chuẩn</p>
                            </div>
                            <div className="col-sm-3 col-xl-2 border-right">
                                <p>Gói kinh doanh</p>
                            </div>
                            <div className="col-sm-3 col-xl-2">
                                <p>Theo cách sử dụng</p>
                            </div>

                        </div>
                        <div className='table-body'>
                            <div className='col-sm-12'>
                                <div className="row">
                                    <div className="col-sm-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Số lượng mã mỗi tháng</p>
                                            <p className='text-left table-sub-title pt-5'>Mã bảo mật Qrypto được tạo</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>250/tháng + thêm 30¢ mỗi mã</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>900/tháng + thêm 20¢ mỗi mã</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>3500/tháng + thêm 15¢ mỗi mã</p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p>Định giá dựa trên số lượng</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Kích thước tối đa cho mỗi mã EDC</p>
                                            <p className='text-left table-sub-title pt-5'>Đây là kích thước tối đa của tất cả dữ liệu và tệp đính kèm để có mã EDC an toàn.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>10MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>25MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>50MB</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>As Per Need</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col pt-xl-8'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tổng dung lượng lưu trữ</p>
                                            <p className='text-left table-sub-title pt-5'>Tổng dung lượng được sử dụng bởi tất cả các tệp đính kèm</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Không giới hạn</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Không giới hạn</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>Không giới hạn</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='px-10-py-20'>
                                            <p>N.A.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>API Tokens</p>
                                            <p className='text-left table-sub-title pt-5'>Thiết lập và quản lý API Tokens để ứng dụng của bạn sử dụng nhằm tạo tài liệu bảo mật</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tích hợp nhóm S3 của bạn</p>
                                            <p className='text-left table-sub-title pt-5'>Sử dụng dịch vụ lưu trữ Amazon AWS (S3) của riêng bạn để lưu trữ tệp đính kèm</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Trình xác thực web</p>
                                            <p className='text-left table-sub-title pt-5'>Xác thực mã bảo mật chỉ bằng trình duyệt và miền của bạn.
                                                <br />
                                                <LinkWhiteHoverOrange href="https://validation.qrypto.ee" target='_blank'>Ví dụ:https://validation.qrypto.ee</LinkWhiteHoverOrange>
                                            </p>

                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tùy chỉnh trình xác thực web</p>
                                            <p className='text-left table-sub-title pt-5'>Tùy chỉnh trang xác thực Web</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <p className='pt-xl-12'>
                                            Chỉ hỗ trợ Logo
                                        </p>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tùy chọn QR - URL</p>
                                            <p className='text-left table-sub-title pt-5'>Điều này làm cho nội dung QR bảo mật trở thành một URL cho phép sử dụng các máy quét mã QR chung. Điều này có thể có ý nghĩa bảo mật - vui lòng liên hệ để được hướng dẫn.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">

                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>

                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Mã dữ liệu chính (PDC)</p>
                                            <p className='text-left table-sub-title pt-5'>Tạo Mã QR chỉ có văn bản độc lập để xác thực ngoại tuyến. Xem <LinkWhiteHoverOrange href="technology/overview">PDC và EDC</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Đóng dấu PDF</p>
                                            <p className='text-left table-sub-title pt-5'>Bảo mật tệp PDF hiện có bằng cách dán mã QR an toàn lên tệp PDF hiện có. <LinkWhiteHoverOrange>Đọc thêm</LinkWhiteHoverOrange></p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tạo PDF: Phí thiết lập một lần cho mỗi mẫu</p>
                                            <p className='text-left table-sub-title pt-5'>Tạo PDF bảo mật với dữ liệu có thể thay đổi và thêm mã QR bảo mật Qrypto để xác thực dễ dàng.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>$250</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Số lượng người dùng</p>
                                            <p className='text-left table-sub-title pt-5'>Số lượng nhân viên của bạn sử dụng hệ thống để tạo Mã/Tài liệu Bảo mật. Bất kỳ ai da xác thực mã đều không được tính là người dùng.</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>5 + thêm $5 cho mỗi người dùng</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>10 + thêm $5 cho mỗi người dùng</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <p>25 + thêm $5 cho mỗi người dùng</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>Theo nhu cầu</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>Tài khoản phụ</p>
                                            <p className='text-left table-sub-title pt-5'>Nhân viên của bạn sử dụng hệ thống để tạo mức sử dụng Kết hợp an toàn trên nhiều miền khác nhau nếu tổ chức của bạn quản lý một số miền. Mỗi tên miền bổ sung là một tài khoản phụ</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">

                                        <div className='pt-xl-40'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>

                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-40'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-30'>
                                            <p>$25 cho mỗi tài khoản phụ với 250 mã</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-40'>
                                            <p>Theo nhu cầu</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body'>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>QR hóa đơn điện tử KSA</p>
                                            <p className='text-left table-sub-title pt-5'>Qrypto cung cấp giải pháp QR sẵn sàng để sử dụng cho Giai đoạn 1 của hóa đơn điện tử KSA</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-22'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-body' style={{ borderBottom: "none" }}>
                            <div className='col-xs-12'>
                                <div className="row">
                                    <div className="col-xs-12 col-xl-4 border-bottom-max1199">
                                        <div className='feature-col'>
                                            <p className='text-left font-weight-semi-bold table-title'>SLA</p>
                                            <p className='text-left table-sub-title pt-5'>Thỏa thuận cấp độ dịch vụ</p>
                                        </div>
                                    </div>

                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={closed_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                    <div className="col-xs-3 col-xl-2 pt-15-max1199">
                                        <div className='pt-xl-12'>
                                            <img src={checked_red} alt="checked_red" className='checked-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='table-footer'>
                            <div className="hidden xl-block col-xl-4">
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>{t('button.sign-up')}</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>{t('button.sign-up')}</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>{t('button.sign-up')}</PrimaryButton>
                            </div>
                            <div className="col-xs-3 col-xl-2">
                                <PrimaryButton style={{padding:"0 5px"}} 
                                onClick={() => setModalCloudPlansOpen(true)}>{t('button.contact-us')}</PrimaryButton>
                            </div>
                            {language === "en"
                            ?
                            <div className='col-xs-12 pt-20'>
                                <p className='font-weight-semi-bold'>Start with free trial for Standard and then choose a paid plan</p>
                                <p className='italic text-gray'>All prices are in USD</p>
                            </div>
                            :
                            <div className='col-xs-12 pt-20'>
                                <p className='font-weight-semi-bold'>Bắt đầu dùng thử miễn phí gói Tiêu chuẩn và sau đó chọn gói trả phí</p>
                                <p className='italic text-gray'>Tất cả giá đều tính bằng USD</p>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            }
            {modalGetTrialOpen && <ModalContactGetTrialForm
                setOpenModal={setModalGetTrialOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalGetTrialRef} />}
            {modalCloudPlansOpen && <ModalPricingCloudPlans
                setOpenModal={setModalCloudPlansOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalCloudPlansRef} />}
        </>
    )
}

export default PricingCloudPlansComparison